export interface CreateAttribute {
    attributeAutoIncrement: string,
    attributeDataType: string,
    attributeDecimalLimit: string,
    attributeDefaultValue: string,
    attributeEntityId: number,
    attributeForeignKey: string,
    attributeIsRequiredCreate: string,
    attributeIsRequiredDelete: string,
    attributeIsRequiredUpdate: string,
    attributeLength: string,
    attributeName: string,
    attributeNull: string,
    attributePrimaryKey: string,
    attributeReferenceAttribute: string,
    attributeReferenceEntity: string,
    attributeStartValue: number,
    attributeStep: number,
    attributeTestData: string,
    attributeUnique: string,
    attributeValueList: string
}

export const CreateAttributeInit: CreateAttribute = {
    attributeAutoIncrement: "",
    attributeDataType: "",
    attributeDecimalLimit: "",
    attributeDefaultValue: "",
    attributeEntityId: 0,
    attributeForeignKey: "",
    attributeIsRequiredCreate: "",
    attributeIsRequiredDelete: "",
    attributeIsRequiredUpdate: "",
    attributeLength: "",
    attributeName: "",
    attributeNull: "",
    attributePrimaryKey: "",
    attributeReferenceAttribute: "",
    attributeReferenceEntity: "",
    attributeStartValue: 0,
    attributeStep: 0,
    attributeTestData: "",
    attributeUnique: "",
    attributeValueList: "",
}